import Component from '../abstracts/Component';
import Cookies from 'js-cookie'
import TrackingComponent from './TrackingComponent';

export default class NewsletterComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-modal-form-contents',
      form: '.js-newsletter-form',
      modalForm: '.js-newsletter-form',
      cta: '.nl-submission',
      privacy: '.js-wrapper-privacy',
      inputEmail: '.js-email-input',
      checkboxGroup: '.checkboxes-group'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
    this.form = $(this.SELECTORS.form);
    this.container = $(this.SELECTORS.container);
    this.trackingComponent = new TrackingComponent();
  }

  updateSubmitButton ($email) {
    let emailHasError = $email.hasClass( "error" );
    let form = $email.closest('form');
    let checkboxes = form.find('input[name="marina"], input[name="persona"]');
    let checkedCheckboxes = 0;
    checkboxes.each((index, element)=>{
      let $el = $(element);
      if($el.is(':checked')) checkedCheckboxes++;
    });
    // console.log(checkedCheckboxes);

    let $privacy = form.find(this.SELECTORS.privacy);
    let id = $privacy.attr('id');
    let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
    let checked = $privacy.is(':checked');

    if (checked && !emailHasError && checkedCheckboxes > 0) {
      $(basicNewsletterSubmit).attr("disabled", false);
    } else {
      $(basicNewsletterSubmit).attr("disabled", true);
    }
  };

  bindEvents(el) {

    let ctx = this,
      $element = $(el);

    $element.find(ctx.SELECTORS.form).on('submit.newsletter', function (e) {
      e.preventDefault();
      let $this = $(this);
      let url = $this.attr('action');
      let $submit = $this.find(ctx.SELECTORS.cta);

      $this.find(ctx.SELECTORS.cta).html('');
      ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
        button: $submit,
      });

      $.ajax({
        type: "POST",
        url: url,
        data: $this.serialize(),
        success: (html) => {
          ctx.log('Newsletter ajax success...');
          let error = $(html).find('span.error').length > 0;
          
          ctx.trackingComponent.trackAction('newsletterSubscribe', $submit[0].dataset , $submit[0]);

          let currentWrapper = $this.closest(ctx.SELECTORS.form).first();
          currentWrapper.fadeOut(300, ()=>{
            currentWrapper.html($(html).find(ctx.SELECTORS.container).html());
            currentWrapper.fadeIn(300);
          });

          // $this.closest(ctx.SELECTORS.container).html($(html).find(ctx.SELECTORS.container).html());

          Cookies.set('nlRegistered', true, {
            expires: 365
          });
        },
        error: function (html) {
          console.log('nl submit error ');
          console.log($this.serialize())
        }
      });
    });

    $element.find(ctx.SELECTORS.inputEmail).on('focus.newsletter', function (e) {
      let checkboxes = $element.find(ctx.SELECTORS.checkboxGroup);
      checkboxes.addClass(ctx.CLASSES.show);
    });

    // force validation on change
    $element.find(ctx.SELECTORS.inputEmail).on('focusout.newsletter', function (e) {
      document.newsletterBouncer.validate(this);
      const $email = $(this);
      ctx.updateSubmitButton($email);
    });

    $element.find(`${ctx.SELECTORS.checkboxGroup} input`).on('change.nlCheckboxes', function (e) {
      const form = $(this).closest('form');
      const $email = form.find(ctx.SELECTORS.inputEmail);
      ctx.updateSubmitButton($email);
    });

    // show/collapse nl module
    $('body').on('click.newsletter', function (e) {
      let checkboxes = $element.find(ctx.SELECTORS.checkboxGroup);
      let isChild = $(e.target).closest($element).length;
      let leaveOpen = $element.find(ctx.SELECTORS.inputEmail).val() != '';
      if($(e.target).is($element.find(ctx.SELECTORS.inputEmail))){
        checkboxes.addClass(ctx.CLASSES.show);
      }else if (!leaveOpen && isChild == 0 && checkboxes.hasClass(ctx.CLASSES.show)) {
        checkboxes.removeClass(ctx.CLASSES.show);
      }else if (leaveOpen && checkboxes.hasClass(ctx.CLASSES.show)){
        checkboxes.addClass(ctx.CLASSES.show);
      }
    });
  }

  render() {
    if (this.container.length) {
      this.container.each((index, element) => {
        this.bindEvents(element);
      })
    }
  }
}
